<div class="table-responsive animated fadeIn slow">

    <div class="text-center mb-3">
        <h2 class="titulo d-inline-block">

            <span class="d-none d-sm-inline">
                LISTADO DE FACTURAS DE RECURSOS MATERIALES
            </span>

        </h2>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">

        <div>
            <button type="button" class="btn btn-agregar" title="Agregar factura desde archivo XML timbrado" (click)="abrirAgregarXML()">

                <i class="fas fa-file-invoice-dollar"></i>

                Cargar Factura XML
            </button>
            <button type="button" class="btn btn-agregar" data-toggle="modal" data-target="#agregarfacturamanual" title="Agregar factura manual">

                <i class="fas fa-file-invoice-dollar"></i>

                Cargar Factura Manual
            </button>
        </div>

        <div class="form-inline bg-light p-2 rounded shadow-sm">

            <label class="mr-2 font-weight-bold mb-0" style="color:#720f3c;">
                Filtrar por Estado:
            </label>

            <select class="form-control form-control-sm border-primary font-weight-bold" style="min-width: 150px;" (change)="filtrarPorEstado($event.target.value)">

                <option value="">Todos</option>
                <option value="VIGENTE">Vigente</option>
                <option value="CANCELADO">Cancelado</option>
                <option value="PAGADO">Pagado</option>
            </select>

        </div>

    </div>

    <div class="table-wrapper">

        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">

            <thead>
                <tr>
                    <th>Folio</th>
                    <th>Emisor</th>
                    <th>Subtotal</th>
                    <th>Total</th>
                    <th>Fecha Carga</th>
                    <th>UUID</th>
                    <th>Estado CFDI</th>
                    <th>Fecha UUID</th>
                    <th>Comentarios</th>
                    <th>Acciones</th>
                    <th>Eliminar</th>
                </tr>
            </thead>

            <tbody>

                <tr *ngFor="let f of facturasMateriales">

                    <td data-label="Folio">
                        {{ f.folio || 'S/N' }}
                    </td>

                    <td data-label="Emisor">
                        {{ f.nombre_emisor || '---' }}
                    </td>

                    <td data-label="Subtotal">
                        {{ f.subtotal | currency }}
                    </td>

                    <td data-label="Total">
                        {{ f.total | currency }}
                    </td>

                    <td data-label="Fecha Carga">
                        {{ f.fecha_guardado | date:'dd/MM/yy HH:mm' }}
                    </td>

                    <td data-label="UUID">
                        {{ f.uuid }}
                    </td>

                    <td data-label="Estado CFDI">

                        <strong>

                            <span [ngClass]="{
                                'estatus-vigente': f.estado_cfdi === 'VIGENTE',
                                'estatus-cancelado': f.estado_cfdi === 'CANCELADO',
                                'estatus-no-encontrado': f.estado_cfdi === 'NO ENCONTRADO'
                            }">

                                {{ f.estado_cfdi || '---' }}

                            </span>

                        </strong>

                    </td>
                    <td data-label="Fecha UUID">
                        {{ f.fecha_timbrado | date:'dd/MM/yy HH:mm' }}
                    </td>

                    <td data-label="Comentarios">
                        <small>{{ f.comentarios || '---' }}</small>
                    </td>

                    <td>

                        <button class="btn-guardar" title="Editar datos de factura" (click)="editarFactura(f)">

                            <i class="fa-solid fa-pen-to-square"></i>
                            Editar

                        </button>

                    </td>
                    <td>
                        <button class="btn-eliminar" title="Eliminar factura" (click)="eliminarFactura(f)">

        <i class="fa-solid fa-trash"></i>
        Eliminar

    </button>
                    </td>
                </tr>

            </tbody>

        </table>

    </div>

</div>


<!-- ========================= -->
<!-- MODAL CARGAR XML -->
<!-- ========================= -->

<div class="modal fade" id="Agrexml" tabindex="-1" role="dialog" aria-hidden="true">

    <div class="modal-dialog modal-lg" role="document">

        <div class="modal-content modal-asig">

            <div class="modal-header-asig">

                <h2 class="modal-title-asig">
                    Cargar Factura XML
                </h2>

            </div>

            <div class="modal-body-asig">

                <div class="container-asig">

                    <div class="row mt-3">

                        <div class="col-lg-12">

                            <label for="xmlFile">
                                <b>Seleccionar archivo XML:</b>
                            </label>

                            <input type="file" id="xmlFile" accept=".xml" multiple class="form-control" (change)="onFileSelected($event)">

                        </div>

                    </div>

                </div>

                <div class="modal-footer-asig">

                    <button type="button" class="btn-cancelar" (click)="cerrarAgregarXML()">

                        Cerrar

                    </button>

                </div>

            </div>

        </div>

    </div>

</div>


<!-- ========================= -->
<!-- MODAL PREVISUALIZACIÓN -->
<!-- ========================= -->

<div class="modal fade" id="previewXML" tabindex="-1" role="dialog" aria-hidden="true">

    <div class="modal-dialog modal-lg" role="document">

        <div class="modal-content modal-asig">

            <div class="modal-header-asig">

                <h2 class="modal-title-asig">
                    Previsualización de datos de la factura
                </h2>

            </div>

            <div class="modal-body-asig">

                <form #f="ngForm">

                    <!-- FILA 1 -->
                    <div class="row">

                        <div class="col-md-3">
                            <label>Folio:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.folio" name="folio" readonly>
                        </div>

                        <div class="col-md-3">
                            <label>Subtotal:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.subtotal" name="subtotal" readonly>
                        </div>

                        <div class="col-md-3">
                            <label>Descuento:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.descuento" name="descuento" readonly>
                        </div>

                        <div class="col-md-3">

                            <label>Total:</label>

                            <div class="input-group">

                                <input class="form-control fw-bold" [(ngModel)]="xmlPreview.total" name="total" readonly>

                                <div class="input-group-append">

                                    <button class="btn btn-outline-secondary btn-sm btn-copiar" type="button" (click)="copiarAlPortapapeles(xmlPreview.total)">

                                        Copiar

                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>


                    <!-- FILA 2 -->
                    <div class="row mt-3">

                        <div class="col-md-4">

                            <label>IVA 16%:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.iva16" name="iva16" readonly>

                        </div>

                        <div class="col-md-4">

                            <label>Base 0%:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.base0" name="base0" readonly>

                        </div>

                        <div class="col-md-4">

                            <label>Total Impuestos:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.impuestos" name="impuestos" readonly>

                        </div>

                    </div>


                    <!-- FILA 3 -->
                    <div class="row mt-3">

                        <div class="col-md-4">

                            <label><b>RFC Emisor:</b></label>

                            <div class="input-group">

                                <input class="form-control" [(ngModel)]="xmlPreview.rfc_emisor" name="rfc_emisor">

                                <button class="btn btn-outline-secondary btn-sm" type="button" (click)="copiarAlPortapapeles(xmlPreview.rfc_emisor)" style="font-size:0.8rem; padding:0.25rem 0.5rem;">

                                    <i class="fa-regular fa-clipboard"></i>
                                    Copiar

                                </button>

                            </div>

                        </div>

                        <div class="col-md-8">

                            <label>Nombre Emisor:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_emisor" name="nombre_emisor">

                        </div>

                    </div>


                    <!-- FILA 4 -->
                    <div class="row mt-3">

                        <div class="col-md-4">

                            <label><b>RFC Receptor:</b></label>

                            <div class="input-group">

                                <input class="form-control" [(ngModel)]="xmlPreview.rfc_receptor" name="rfc_receptor">

                                <button class="btn btn-outline-secondary btn-sm" type="button" (click)="copiarAlPortapapeles(xmlPreview.rfc_receptor)" style="font-size:0.8rem; padding:0.25rem 0.5rem;">

                                    <i class="fa-regular fa-clipboard"></i>
                                    Copiar

                                </button>

                            </div>

                        </div>

                        <div class="col-md-8">

                            <label>Nombre Receptor:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_receptor" name="nombre_receptor">

                        </div>

                    </div>


                    <!-- FILA 5 -->
                    <div class="row mt-3">

                        <div class="col-md-8">

                            <label><b>UUID:</b></label>

                            <div class="input-group">

                                <input class="form-control" [(ngModel)]="xmlPreview.uuid" name="uuid" readonly>

                                <button class="btn btn-outline-secondary btn-sm" type="button" (click)="copiarAlPortapapeles(xmlPreview.uuid)" style="font-size:0.8rem; padding:0.25rem 0.5rem;">

                                    <i class="fa-regular fa-clipboard"></i>
                                    Copiar

                                </button>

                            </div>

                        </div>

                        <div class="col-md-4">

                            <label>No. Certificado SAT:</label>

                            <input class="form-control" [(ngModel)]="xmlPreview.no_certificado_sat" name="no_certificado_sat">

                        </div>

                    </div>


                    <!-- ESTADO CFDI -->
                    <div class="row mt-3">

                        <div class="col-md-4">

                            <label><b>Estado CFDI:</b></label>

                            <select class="form-control" [(ngModel)]="xmlPreview.estado_cfdi" name="estado_cfdi" (change)="onEstadoCfdiChange()" [ngClass]="{
                                    'border-danger': xmlPreview.estado_cfdi === 'CANCELADO',
                                    'border-success': xmlPreview.estado_cfdi === 'VIGENTE'
                                }">

                                <option value="" disabled>
                                    Seleccione uno...
                                </option>

                                <option value="VIGENTE">
                                    VIGENTE
                                </option>

                                <option value="CANCELADO">
                                    CANCELADO
                                </option>

                                <option value="PAGADO">
                                    PAGADO
                                </option>

                            </select>

                        </div>


                        <!-- BOTÓN SAT -->
                        <div class="col-md-6 align-self-end mt-3 mt-md-0" *ngIf="xmlPreview.estado_cfdi !== 'CANCELADO' && xmlPreview.uuid">

                            <button class="btn-guardar" type="button" (click)="abrirSATConInstrucciones()">

                                <i class="fas fa-external-link-alt"></i>

                                Verificar en la página del SAT

                            </button>

                        </div>


                        <!-- CANCELADO -->
                        <div class="col-md-8" *ngIf="xmlPreview.estado_cfdi === 'CANCELADO'">

                            <div class="alert alert-danger fade-in" role="alert" style="padding:12px 16px; margin-bottom:0;">

                                <div class="d-flex align-items-center">

                                    <i class="fas fa-exclamation-triangle fa-2x mr-3 text-danger"></i>

                                    <div>

                                        <strong class="d-block">
                                            Factura CANCELADA
                                        </strong>

                                        <small>
                                            Seleccione el estatus de cancelación ante el SAT:
                                        </small>

                                    </div>

                                </div>

                                <div class="mt-3">

                                    <select class="form-control form-control-sm border-danger" [(ngModel)]="xmlPreview.motivo_cancelacion" name="motivo_cancelacion" required>

                                        <option value="" disabled selected>
                                            Seleccione estado de cancelación
                                        </option>

                                        <option value="01">
                                            Cancelado con aceptación
                                        </option>

                                        <option value="02">
                                            Cancelado sin aceptación
                                        </option>

                                        <option value="03">
                                            Plazo vencido
                                        </option>

                                        <option value="04">
                                            No registrado
                                        </option>

                                    </select>

                                    <small class="text-muted d-block mt-1">
                                        Este valor no se guarda en la base de datos,
                                        solo el "Estado CFDI".
                                    </small>

                                </div>

                            </div>

                        </div>

                    </div>


                    <!-- COMENTARIOS -->
                    <div class="row mt-3">

                        <div class="col-md-12">

                            <label>Comentarios:</label>

                            <textarea class="form-control textarea-comentarios" [(ngModel)]="xmlPreview.comentarios" name="comentarios" rows="1" style="font-size:0.8rem; padding:0.25rem 0.5rem;" placeholder="Escribe aquí cualquier observación adicional..."></textarea>

                        </div>

                    </div>

                </form>

            </div>


            <!-- FOOTER -->
            <div class="modal-footer-asig">

                <button class="btn-guardar mx-2" type="button" (click)="confirmarXML()">

                    <i class="fa-regular fa-floppy-disk"></i>

                    <b>
                        {{ esModoEdicion ? ' Guardar Cambios' : ' Confirmar y Almacenar' }}
                    </b>

                </button>

                <button class="btn-cancelar mx-2" type="button" (click)="cerrarPreviewXML()">

                    <i class="fa-solid fa-xmark"></i>

                    Cancelar

                </button>

            </div>

        </div>


    </div>

</div>

<!-- ///////////////////////nuevo//////////////////////////// -->

<div class="modal fade" id="agregarfacturamanual" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">AGREGAR FACTURA MANUAL</h2>
            </div>

            <div class="modal-body-asig">

                <form #f="ngForm">

                    <div class="row">

                        <div class="col-md-2">
                            <label>Folio:</label>

                            <input type="number" class="form-control" name="folio" [(ngModel)]="facturasmanual.folio" required>
                        </div>


                        <div class="col-md-6">

                            <label>Nombre del empleado:</label>

                            <input type="text" class="form-control mb-2" placeholder="Escribe para buscar..." [(ngModel)]="busquedaEmpleado" name="busquedaEmpleado" (input)="filtrarEmpleado()">

                            <select class="form-control" [(ngModel)]="facturasmanual.nombreempleado" name="nombreempleado" (change)="seleccionarEmpleado()">

                                <option value="">
                                    Selecciona empleado
                                </option>

                                <option *ngFor="let emp of empleadoFiltrado"
                                        [ngValue]="emp.nompersonal">

                                    {{emp.nompersonal}}

                                </option>

                            </select>

                        </div>


                        <div class="col-md-4">

                            <label>RFC:</label>

                            <input type="text" class="form-control" [(ngModel)]="rfcEmpleado" name="RFC" disabled>

                        </div>

                    </div>


                    <div class="row mt-3">

                        <div class="col-md-4">

                            <label>RFC Contabilidad:</label>

                            <input type="text" class="form-control" value="AAAA111111ZZZ" disabled>

                        </div>

                        <div class="col-md-4">

                            <label>Fecha:</label>

                            <input type="date" class="form-control" [(ngModel)]="facturasmanual.fecha_timbrado" name="fecha_timbrado">

                        </div>

                        <div class="col-md-4">

                            <label>Monto:</label>

                            <input type="number" class="form-control" [(ngModel)]="facturasmanual.total" name="total">

                        </div>

                    </div>

                </form>

            </div>

            <div class="modal-footer-asig">
                <button class="btn-guardar" (click)="subirFacturaManual()">Guardar</button>
                <button class="btn-cancelar" type="button" data-dismiss="modal">Cancelar</button>
            </div>

        </div>
    </div>
</div>